import type { AxiosInstance } from 'axios'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'aiUsages'

export type AiUsageFeature =
  | 'recruitment_ai_screening'
  | 'recruitment_cv_extraction'
  | 'school_ai_matching'
  | 'documentation_search'
  | 'evaluation_question_analysis'
  | 'evaluation_word_cloud'
  | 'evaluation_bulk_summaries'
  | 'evaluation_pdf_language_detect'
  | 'evaluation_pdf_translate'
  | 'expense_bill_extraction'
  | 'elearning_course_import'
  | 'elearning_course_audio'
  | 'elearning_course_translation'
  | 'training_plan_assistant'
  | 'formular_pdf_import'
  | 'marketing_image_generation'
  | 'ticket_message_improve'
  | 'salesAskCrm'
  | 'salesResearchAgent'
  | 'salesFollowUpAgent'
  | 'salesMcpTool'
  | 'salesDueDiligenceDeepResearch'
  | 'salesDueDiligenceEnrichment'
  | 'salesDueDiligenceContactResearch'
  | 'salesDueDiligenceEvaluationInsights'
  | 'assistantAsk'
  | 'assistantDocs'
  | 'assistantLeave'
  | 'assistantEvaluation'
  | 'academy_ticket_context'
  | 'other'

export type AiUsageSummaryRow = {
  firmId: string | null
  firm: { _id: string, company: string, code?: string } | null
  feature: AiUsageFeature | null
  model: string | null
  requestCount: number
  promptTokens: number
  inputTokens: number
  cachedTokens: number
  completionTokens: number
  thoughtsTokens: number
  totalTokens: number
  costUsd: number
  costInputUsd: number
  costCachedUsd: number
  costOutputUsd: number
  costUsdStandard: number
  costInputUsdStandard: number
  costCachedUsdStandard: number
  costOutputUsdStandard: number
}

export type AiUsageTotals = {
  requestCount: number
  promptTokens: number
  inputTokens: number
  cachedTokens: number
  completionTokens: number
  thoughtsTokens: number
  totalTokens: number
  costUsd: number
  costInputUsd: number
  costCachedUsd: number
  costOutputUsd: number
  costUsdStandard: number
  costInputUsdStandard: number
  costCachedUsdStandard: number
  costOutputUsdStandard: number
}

export type AiUsageSummaryResponse = {
  summary: AiUsageSummaryRow[]
  totals: AiUsageTotals
}

const emptyTotals = (): AiUsageTotals => ({
  requestCount: 0,
  promptTokens: 0,
  inputTokens: 0,
  cachedTokens: 0,
  completionTokens: 0,
  thoughtsTokens: 0,
  totalTokens: 0,
  costUsd: 0,
  costInputUsd: 0,
  costCachedUsd: 0,
  costOutputUsd: 0,
  costUsdStandard: 0,
  costInputUsdStandard: 0,
  costCachedUsdStandard: 0,
  costOutputUsdStandard: 0,
})

export { emptyTotals }

const getSummary = (axios: any) => (query: {
  firmId?: string
  feature?: string
  model?: string
  startDate?: string | Date
  endDate?: string | Date
  groupBy?: string
}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/summary`,
    query,
  })
}

const listUsage = (axios: any) => (query: {
  firmId?: string
  feature?: string
  model?: string
  startDate?: string | Date
  endDate?: string | Date
  page?: number
  limit?: number
}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    query,
  })
}

export default (axios: AxiosInstance) => ({
  getSummary: getSummary(useAxios(axios)),
  listUsage: listUsage(useAxios(axios)),
})
